import React from 'react';
import { useNavigate } from 'react-router-dom';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const SuccessModal = ({ proofData, onClose }) => {
  const navigate = useNavigate();

  const handleViewProof = () => {
    navigate('/proof-detail-view', { state: { proofId: proofData?.id } });
  };

  const handleBackToChallenge = () => {
    navigate('/challenge-detail', { state: { challengeId: proofData?.challengeId } });
  };

  return (
    <div className="fixed inset-0 z-dialog bg-background/80 backdrop-blur-sm flex items-center justify-center p-4">
      <div className="bg-card rounded-lg shadow-gaming-lg p-6 md:p-8 max-w-md w-full">
        <div className="flex flex-col items-center space-y-6">
          <div
            className="w-20 h-20 md:w-24 md:h-24 bg-success/20 rounded-full flex items-center justify-center"
          >
            <Icon
              name="CheckCircle"
              size={48}
              color="var(--color-success)"
              className="md:w-16 md:h-16"
            />
          </div>

          <div className="text-center space-y-2">
            <h3 className="text-xl md:text-2xl font-heading font-semibold text-foreground">
              증명 제출 완료!
            </h3>
            <p className="text-sm md:text-base text-muted-foreground caption">
              {proofData?.proofNumber}번째 증명이 성공적으로 등록되었습니다
            </p>
          </div>

          <div className="w-full p-4 bg-muted/50 rounded-lg space-y-2">
            <div className="flex items-center justify-between">
              <span className="text-sm text-muted-foreground caption">제목</span>
              <span className="text-sm font-medium text-foreground">{proofData?.title}</span>
            </div>
            <div className="flex items-center justify-between">
              <span className="text-sm text-muted-foreground caption">평가</span>
              <div className="flex items-center space-x-1">
                {[...Array(5)]?.map((_, index) => (
                  <Icon
                    key={index}
                    name="Star"
                    size={14}
                    color={
                      index < proofData?.rating
                        ? 'var(--color-accent)'
                        : 'var(--color-muted)'
                    }
                    className={index < proofData?.rating ? 'fill-current' : ''}
                  />
                ))}
              </div>
            </div>
            <div className="flex items-center justify-between">
              <span className="text-sm text-muted-foreground caption">공개 설정</span>
              <div className="flex items-center space-x-1">
                <Icon
                  name={proofData?.isPublic ? 'Globe' : 'Lock'}
                  size={14}
                  color="var(--color-muted-foreground)"
                />
                <span className="text-sm font-medium text-foreground">
                  {proofData?.isPublic ? '공개' : '비공개'}
                </span>
              </div>
            </div>
          </div>

          <div className="w-full space-y-3">
            <Button variant="default" fullWidth onClick={handleViewProof}>
              증명 상세 보기
            </Button>
            <Button variant="outline" fullWidth onClick={handleBackToChallenge}>
              챌린지로 돌아가기
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SuccessModal;